import React, { Component } from 'react'
import PropTypes from 'prop-types'
import style from './NumberSpinner.less'
import Svg from 'tickets/components/common/Svg'
import ChevronDown from 'styles/icons/chevron_down.svg'
import ChevronUp from 'styles/icons/chevron_up.svg'
import classNames from 'classnames'
import { padWithZero } from 'common/utils/stringUtils'

class NumberSpinner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      stepNumber: props.startNumber,
      numSteps: Math.round(props.maxNumber / props.stepSize),  // Must evenly divide
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.stepNumber !== prevState.stepNumber) {
      this.props.onChange(this.state.stepNumber * this.props.stepSize)
    }
  }

  moveUp = () => {
    this.setState((prevState) => ({
      stepNumber: (prevState.stepNumber - 1 + this.state.numSteps) % this.state.numSteps,
    }))
  }

  moveDown = () => {
    this.setState((prevState) => ({
      stepNumber: (prevState.stepNumber + 1) % this.state.numSteps,
    }))
  }

  render() {
    const { stepSize, title, isTime } = this.props
    const { stepNumber, numSteps } = this.state
    const yPos = 27 - (30 * stepNumber)
    const moverStyle = { transform: `translate(0, ${yPos}px)` }

    return (
      <div className={style.main} data-test="numberSpinner">
        <div className={style.title}>{title}</div>
        <div onClick={this.moveUp} data-test="numberSpinnerUp">
          <Svg className={style.arrow} svg={ChevronUp} />
        </div>
        <div className={style.numbersContainer}>
          <div className={style.numbersMover} style={moverStyle}>
            {[...Array(numSteps)]
              .map((e, i) => {
                const classes = (i == stepNumber)
                  ? classNames([style.row, style.active])
                  : style.row
                const labelNum = (stepSize) ? i * stepSize : i
                const label = (isTime) ? padWithZero(labelNum) : labelNum
                return <span className={classes} key={i}>{label}</span>
              })
            }
          </div>
        </div>
        <div onClick={this.moveDown} data-test="numberSpinnerDown">
          <Svg className={style.arrow} svg={ChevronDown} />
        </div>
      </div>
    )
  }
}

NumberSpinner.defaultProps = {
  stepSize: 1,
  startNumber: 0,
}

NumberSpinner.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  startNumber: PropTypes.number,
  maxNumber: PropTypes.number.isRequired,
  stepSize: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  isTime: PropTypes.bool,
}

export default NumberSpinner
